// extracted by mini-css-extract-plugin
module.exports = {"screenshot_wrapper":"styles_screenshot_wrapper__2Xnqv","screen_img":"styles_screen_img__G_q8F","download":"styles_download__cQKlR"};